import { isExternalUrl } from "./urlHelper.js";
import { regexValidUrl, regexValidRelativeUrl } from "./regex.js";
import { POST_LABEL } from "./constants.js";

/**
 * Get the campaign parameters for Cosmos.
 * @param {string} campaignToDonationLink - The donation link for the campaign. e.g./donate/give/starlight-moments?&cosmos_campaign_id_c=a53c1a1b-b2a5-ec11-983f-000d3a6ac86a
 * @param {object} urlParams - The URL parameters.
 * @param {object|null} extraParams
 * @param {null|string} cosmosCampaignId - The campaign ID for Cosmos.
 * @param {string|null} hashId e.g. formId
 * @returns {string} - The campaign parameters for Cosmos.
 */
export const getUrlWithCosmosCampaignParams = (campaignToDonationLink, urlParams = {}, cosmosCampaignId = null, hash) => {
  /**
   * Add a new search param to search attribute of URL object
   * @param {URL} url
   * @param {string} newKey
   * @param {string} newValue
   */
  const setSearch = (url, newKey, newValue) => {
    if (newValue) {
      url.searchParams.set(newKey, newValue);
    } else {
      url.searchParams.delete(newKey);
    }
    // url.search += `${url.search ? "&" : ""}${newKey}=${newValue}`;
  };

  campaignToDonationLink = campaignToDonationLink ?? "/donate";

  let url;

  if (isExternalUrl(campaignToDonationLink) ?? false) {
    url = new URL(campaignToDonationLink);
  } else if (regexValidUrl.test(campaignToDonationLink)) {
    url = new URL(campaignToDonationLink, window?.location.href);
  } else if (regexValidRelativeUrl.test(campaignToDonationLink)) {
    //if its realative url but without starting "/", we add it before processing
    if (!campaignToDonationLink.startsWith("/")) {
      url = new URL("/" + campaignToDonationLink, window?.location.href);
    } else {
      url = new URL(campaignToDonationLink, window?.location.href);
    }
  } else {
    url = new URL(window?.location.href);
  }

  const urlParamKeyMap = {
    [POST_LABEL.UTM_CONTENT]: POST_LABEL.UTM_CONTENT,
    [POST_LABEL.UTM_MEDIUM]: POST_LABEL.UTM_MEDIUM,
    [POST_LABEL.UTM_NAME]: POST_LABEL.UTM_NAME,
    [POST_LABEL.UTM_CAMPAIGN]: POST_LABEL.UTM_CAMPAIGN,
    [POST_LABEL.UTM_SOURCE]: POST_LABEL.UTM_SOURCE,
    [POST_LABEL.UTM_TERM]: POST_LABEL.UTM_TERM,
    [POST_LABEL.C_ID]: POST_LABEL.C_ID,
    [POST_LABEL.COSMOS_CAMPAIGN_ID_C]: POST_LABEL.COSMOS_CAMPAIGN_ID_C,
    [POST_LABEL.ADOBE_TARGET]: POST_LABEL.ADOBE_TARGET,
  };

  for (const key in urlParams) {
    if (urlParamKeyMap[key]) {
      const newKey = urlParamKeyMap[key];
      setSearch(url, newKey, urlParams[key]);
    } else if (key === POST_LABEL.COSMOS_CAMPAIGN_ID_C) {
      setSearch(url, POST_LABEL.COSMOS_CAMPAIGN_ID_C, cosmosCampaignId ?? urlParams[key] ?? null);
    } else {
      setSearch(url, key, urlParams[key]);
    }
  }

  if (cosmosCampaignId) {
    setSearch(url, POST_LABEL.COSMOS_CAMPAIGN_ID_C, cosmosCampaignId);
  }

  if (hash) {
    url.hash = hash;
  }

  //if its current host, just use relative path, as gatsby will handle the redirection.
  return url.toString().replace(window?.location.origin, "");
};

export const getUTMPostData = (urlParams) => {
  return {
    [POST_LABEL.UTM_CONTENT]: urlParams[POST_LABEL.UTM_CONTENT] || "",
    [POST_LABEL.UTM_MEDIUM]: urlParams[POST_LABEL.UTM_MEDIUM] || "",
    [POST_LABEL.UTM_NAME]: urlParams[POST_LABEL.UTM_NAME] || "",
    [POST_LABEL.UTM_CAMPAIGN]: urlParams[POST_LABEL.UTM_CAMPAIGN] || "",
    [POST_LABEL.UTM_SOURCE]: urlParams[POST_LABEL.UTM_SOURCE] || "",
    [POST_LABEL.UTM_TERM]: urlParams[POST_LABEL.UTM_TERM] || "",
    [POST_LABEL.C_ID]: urlParams[POST_LABEL.C_ID] || "",
    [POST_LABEL.COSMOS_CAMPAIGN_ID_C]: urlParams[POST_LABEL.COSMOS_CAMPAIGN_ID_C] || "",
    [POST_LABEL.ADOBE_TARGET]: urlParams[POST_LABEL.ADOBE_TARGET] || "",
  };
};
